import { createSlice } from '@reduxjs/toolkit';

export const inActivePolicySlice = createSlice({
  name: 'inActivePolicy',
  initialState: {
    inActive: [
      {
        name: 'Afa 1 2023',
        status: false,
      },
      {
        name: 'Afa 2 2023',
        status: false,
      },
      {
        name: 'Afa 3 2023',
        status: false,
      },
      {
        name: 'Xyz',
        status: false,
      },
      {
        name: 'abc',
        status: false,
      },
      {
        name: 'jkl',
        status: false,
      },
      {
        name: 'qrs',
        status: false,
      },
    ],
  },
  reducers: {
    setInActive(state, { payload }) {
      state.inActive = payload;
    },
  },
});

export const { setInActive } = inActivePolicySlice.actions;
export default inActivePolicySlice.reducer;
